// get all the h2's on the page to add them to a nav list
var h2Elements = document.querySelectorAll("h2");
// Create a list to store the headings
var h2List = [];
// Loop through each h2 element and add its text to the list
h2Elements.forEach(function (element) {
  var trimmedText = element.textContent.trim();

  if (element.classList.contains("visually-hidden")) {
    return; // Skip elements with the class "visually-hidden"
  }

  if (element.classList.contains("cart-notification__heading")) {
    return; // Skip card notification heading
  }

  // don't get the h2's from the footer or the gallery
  if (
    trimmedText !== "" &&
    !element.closest(".footer-hero") &&
    !element.closest(".footer") &&
    !element.closest(".custom-collection-slider")
  ) {
    h2List.push(trimmedText);

    // Add an anchor to the .shopify-section
    var shopifySection = element.closest(".shopify-section"); // Find the closest element with class .shopify-section
    if (shopifySection) {
      shopifySection.id = getAnchorId(trimmedText); // Set the id of the .shopify-section
    }
  }
});
var h2ListContainer = document.getElementById("h2ListContainer");
function smoothScrollTo(targetPosition) {
  window.scrollTo({
    top: targetPosition,
    behavior: "smooth",
  });
}
// Add a click event listener to each link inside the ul
h2ListContainer.addEventListener("click", function (event) {
  event.preventDefault(); // Prevent the default link behavior
  if (event.target.tagName === "A") {
    const anchorId = event.target.getAttribute("href").substring(1); // Get the anchor ID from the href attribute
    const targetSection = document.getElementById(anchorId); // Get the target section element
    if (targetSection) {
      const offset = -75; // Set the desired offset value
      const targetPosition =
        targetSection.getBoundingClientRect().top + window.scrollY + offset;
      smoothScrollTo(targetPosition);
    }
  }
});
// Inject the h2List into the ul as li items wrapped in a tags
h2List.forEach(function (text) {
  var li = document.createElement("li");
  var a = document.createElement("a");
  a.textContent = text;
  a.href = "#" + getAnchorId(text); // Use a function to generate the anchor ID
  li.appendChild(a);
  h2ListContainer.appendChild(li);
});
// Function to generate anchor ID
function getAnchorId(text) {
  return text
    .trim()
    .replace(/[^\w\s]+/g, "")
    .replace(/\s+/g, "_");
}

// Get references to the elements
const productSidebar = document.querySelector(".product-sidebar-container");
let collectionSlider;
let collectionSliderEl = document.querySelector(".collection-slider");
let FAQSection = document.querySelector("#FAQ");

if (collectionSliderEl !== null) {
  collectionSlider = collectionSliderEl;
} else {
  collectionSlider = FAQSection;
}

// console.log(collectionSlider); // You can use collectionSlider as needed

// Function to add the "fixed" class
function addFixedClass() {
  productSidebar.classList.add("fixed");
}
// Function to remove the "fixed" class
function removeFixedClass() {
  productSidebar.classList.remove("fixed");
}
function fadeOut() {
  productSidebar.style.opacity = "0";
}
function fadeIn() {
  productSidebar.style.opacity = "1";
}
// Check viewport width before adding the event listener
if (window.innerWidth > 700) {
  // Initialize a flag to track the scroll direction
  let isScrollingDown = false;
  // Offset for fading out (100px)
  const fadeOutOffset = 2000; // Adjust this value as needed
  // Event listener for the "scroll" event
  window.addEventListener("scroll", () => {
    // Get the current scroll position
    const scrollPosition = window.scrollY;
    // Get the position of the "custom-collection-slider" element
    const collectionSliderPosition =
      collectionSlider.getBoundingClientRect().top + scrollPosition;
    // Check scroll direction
    const newScrollingDown = scrollPosition > collectionSliderPosition;
    // If the scroll direction has changed, update the flag and handle opacity accordingly
    if (newScrollingDown !== isScrollingDown) {
      isScrollingDown = newScrollingDown;
      if (isScrollingDown) {
        // Scrolling down, fade out the productSidebar when reaching the offset
        if (scrollPosition >= collectionSliderPosition - fadeOutOffset) {
          fadeOut();
        }
      } else {
        // Scrolling up, fade in the productSidebar
        fadeIn();
      }
    }
    // Check scroll position to add or remove "fixed" class
    if (scrollPosition >= 650) {
      addFixedClass();
    } else {
      removeFixedClass();
    }
  });
} else {
  productSidebar.style.opacity = "1";
  // Add "fixed" class if needed for smaller viewports
  // Example: addFixedClass();
}
